import { css } from 'styled-components';

export const OceanSkin = css`
  background: linear-gradient(135deg, #74ebd5 0%, #acb6e5 100%);
  border: 2px solid #ffffff88;
  border-radius: 20px;
`;

export const OceanWrapperSkin = css`
  background: linear-gradient(180deg, #a1c4fd 0%, #c2e9fb 100%);
`;

export const OceanLetterSkin = css<{ $isActive: boolean }>`
  color: ${props => (props.$isActive ? '#ffffff' : '#ffffff')};
  opacity: ${props => (props.$isActive ? 1 : 0.3)};
  text-shadow: ${props => (props.$isActive ? '0 0 8px rgba(255,255,255,0.5)' : 'none')};
`;
